import axios from "axios";

const ApiService = {
    anonInstance: axios.create()
};

export default ApiService;
